module.exports = __webpack_public_path__ + "img/ic_modif_blanc.12949119.svg";